import classNames from 'classnames';
import { Button } from 'components/shared/button';
import { Link } from 'gatsby';
import React from 'react';
import Logo from 'svg/logo-with-grafana-labs.inline.svg';
import { app } from 'utils/urls';

import styles from './mobile-nav.module.scss';

export const MobileNav = ({ links, isVisible, onCloseButtonClick }) => (
  <div
    className={classNames(styles.wrapper, {
      [styles.visible]: isVisible,
    })}
  >
    <div className={styles.topSection}>
      <div className={'container'}>
        <div className={'row d-flex align-items-center'}>
          <div className={'col-3'}>
            <Link to={'/'}>
              <Logo className={styles.logo} />
            </Link>
          </div>
          <div className={'col-9 d-flex justify-content-end'}>
            <button className={styles.closeButton} type={'button'} onClick={onCloseButtonClick} />
          </div>
        </div>
      </div>
    </div>

    <div className={`container ${styles.inner}`}>
      <ul className={styles.list}>
        {links.map(({ label, to }) => (
          <li className={styles.listItem} key={label}>
            <a className={styles.listLink} href={to}>
              {label}
            </a>
          </li>
        ))}
      </ul>

      <Button tag={'a'} href={`${app}/account/login`} className={styles.button} size={'sm'} theme={'additional'}>
        Sign in k6 Cloud
      </Button>

      <Button
        tag={'a'}
        href={'https://grafana.com/auth/sign-in/?src=k6io'}
        className={styles.button}
        size={'sm'}
        theme={'additional'}
      >
        Sign in Grafana Cloud k6
      </Button>

      <Button
        tag={'a'}
        href={'https://grafana.com/auth/sign-up/create-user?src=k6io'}
        className={styles.button}
        size={'sm'}
      >
        Sign Up
      </Button>
    </div>
  </div>
);
